import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';

import MuiButton from '../MuiButton';
import { Title } from '../../styles/global';

import NoMatchContainer from './styles';

function NoMatchRouteContent() {
  const history = useHistory();

  return (
    <NoMatchContainer>
      <Title secondary="true" style={{ marginBlockEnd: '4rem' }}>Oopps... nenhuma página encontrada com essa rota</Title>
      {
        /*
          verificamos se o documento está embed em outra pagina
          porque o modal de checkout utiliza este componente como feedback de erro,
          e caso esteja embed escondemos esse botao
          para que nao crie um loop de renderizacao do aplicativo
        */
        window.self === window.top && (
          <MuiButton type="button" onClick={() => history.push('/')}>
            clique aqui para retornar ao app.
          </MuiButton>
        )
      }
    </NoMatchContainer>
  );
}

export default memo(NoMatchRouteContent);
